export const QUALITY_SERVICE_API_URL = window.CONFIG?.qualityServiceDomain || process.env.REACT_APP_QUALITY_SERVICE_DOMAIN;
